import React, { Fragment } from 'react'
import { Container, Image, Nav, Navbar } from 'react-bootstrap'
import Logo from '../../assets/Logo/Favicon/WordpressTransparent.png'
import './Navigation.css'

export default function Navigation() {
  return (
    <Fragment>
      <Navbar collapseOnSelect expand='sm' bg='light' data-bs-theme='light'>
        <Container fluid>
          <Navbar.Brand href='/'>
            <Image src={Logo} alt='Logo' height={62}></Image>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='me-auto'>
              <Nav.Link style={{ color: 'black' }} href='/'>
                Home
              </Nav.Link>
              <Nav.Link style={{ color: 'black' }} href='/About'>
                About
              </Nav.Link>
              <Nav.Link style={{ color: 'black' }} href='/Contact'>
                Contact Us
              </Nav.Link>
              {/* <Nav.Link style={{ color: 'black' }} href='#'>
                Careers
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fragment>
  )
}
